import { Form } from 'react-bootstrap';
import { useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { EditConnectionReference } from 'edit/reference/EditConnectionReference';
import ScriptEditor from '../ui/ScriptEditor';
import { RestConnectionModel, toReference } from './RestConnectionModel';

const Rest = observer(({ state, onChange, readOnly = false }: any) => {
  const { body = '', path = '', method = '', connection = '' } = state.config || {};

  const methodList = ['GET', 'POST', 'PUT', 'DELETE'];

  // `config.connection` may hold an id or a legacy connection name; see RestConnectionModel for how
  // it is resolved, and why that needs every connection loaded first. Until the list arrives nothing
  // is resolved, so the picker is disabled rather than showing a label that may yet change.
  const [connections] = useState(() => new RestConnectionModel());
  const lookup = connections.lookup;
  const loading = lookup.kind === 'loading';
  // Memoized on `lookup`'s identity as well as the stored value: the picker re-syncs, and resets its
  // option list, on every new value object.
  const connectionRef = useMemo(
    () => (lookup.kind === 'loading' ? null : toReference(connection, lookup.kind === 'loaded' ? lookup.connections : null)),
    [connection, lookup]
  );

  return (
    <>
      <Form.Group className="mb-2 w-full" controlId="formNode-method">
        <Form.Label>Method</Form.Label>
        <Form.Select aria-label="method-select" name="method" value={method} onChange={(e) => onChange(e, true)} disabled={readOnly}>
          <option>Select method</option>
          {methodList.map((method, index) => {
            return (
              <option key={index} value={method}>
                {method}
              </option>
            );
          })}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-2 w-full" controlId="formNode-connection">
        <Form.Label>Connection</Form.Label>
        <EditConnectionReference
          type="rest"
          placeholder={loading ? 'Loading...' : 'Search and select a REST connection...'}
          value={connectionRef}
          onChange={(c) => onChange({ target: { name: 'connection', value: c ? String(c.connection_id) : '' } }, true)}
          disabled={readOnly || loading}
        />
      </Form.Group>
      <Form.Group className="mb-2 w-full" controlId="formNode-path">
        <Form.Label>Path</Form.Label>
        <Form.Control type="text" name="path" value={path} onChange={(e) => onChange(e, true)} disabled={readOnly} />
      </Form.Group>

      <ScriptEditor
        label="Body"
        controlId="formNode-body"
        name="body"
        value={body}
        language="json"
        onChange={(e) => onChange(e, true)}
        readOnly={readOnly}
        aria-label="Body editor"
      />
    </>
  );
});

export default Rest;
